
/**
  This file is autogenerated. To update it please run `bundle exec rake frontend:all`
*/

export const PHONE_EXTENSIONS = [
  {
    value: 'AC',
    label: 'AC (+247)',
    prefix: '+247',
    digits: [5, 6]
  },
  {
    value: 'AD',
    label: 'AD (+376)',
    prefix: '+376',
    digits: [8, 6, 9]
  },
  {
    value: 'AE',
    label: 'AE (+971)',
    prefix: '+971',
    digits: [8, 9, 5, 12]
  },
  {
    value: 'AF',
    label: 'AF (+93)',
    prefix: '+93',
    digits: [9]
  },
  {
    value: 'AG',
    label: 'AG (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'AI',
    label: 'AI (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'AL',
    label: 'AL (+355)',
    prefix: '+355',
    digits: [8, 9, 7, 6]
  },
  {
    value: 'AM',
    label: 'AM (+374)',
    prefix: '+374',
    digits: [8]
  },
  {
    value: 'AO',
    label: 'AO (+244)',
    prefix: '+244',
    digits: [9]
  },
  {
    value: 'AR',
    label: 'AR (+54)',
    prefix: '+54',
    digits: [10, 11]
  },
  {
    value: 'AS',
    label: 'AS (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'AT',
    label: 'AT (+43)',
    prefix: '+43',
    digits: [4, 13, 7, 9, 8, 5]
  },
  {
    value: 'AU',
    label: 'AU (+61)',
    prefix: '+61',
    digits: [6, 8, 10, 12, 9, 5, 7]
  },
  {
    value: 'AW',
    label: 'AW (+297)',
    prefix: '+297',
    digits: [7]
  },
  {
    value: 'AX',
    label: 'AX (+358)',
    prefix: '+358',
    digits: [6, 9, 10, 7, 8, 5, 12]
  },
  {
    value: 'AZ',
    label: 'AZ (+994)',
    prefix: '+994',
    digits: [9]
  },
  {
    value: 'BA',
    label: 'BA (+387)',
    prefix: '+387',
    digits: [8, 9]
  },
  {
    value: 'BB',
    label: 'BB (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'BD',
    label: 'BD (+880)',
    prefix: '+880',
    digits: [6, 10]
  },
  {
    value: 'BE',
    label: 'BE (+32)',
    prefix: '+32',
    digits: [8, 9]
  },
  {
    value: 'BF',
    label: 'BF (+226)',
    prefix: '+226',
    digits: [8]
  },
  {
    value: 'BG',
    label: 'BG (+359)',
    prefix: '+359',
    digits: [6, 8, 9, 12]
  },
  {
    value: 'BH',
    label: 'BH (+973)',
    prefix: '+973',
    digits: [8]
  },
  {
    value: 'BI',
    label: 'BI (+257)',
    prefix: '+257',
    digits: [8]
  },
  {
    value: 'BJ',
    label: 'BJ (+229)',
    prefix: '+229',
    digits: [8]
  },
  {
    value: 'BL',
    label: 'BL (+590)',
    prefix: '+590',
    digits: [9]
  },
  {
    value: 'BM',
    label: 'BM (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'BN',
    label: 'BN (+673)',
    prefix: '+673',
    digits: [7]
  },
  {
    value: 'BO',
    label: 'BO (+591)',
    prefix: '+591',
    digits: [9, 8]
  },
  {
    value: 'BQ',
    label: 'BQ (+599)',
    prefix: '+599',
    digits: [7]
  },
  {
    value: 'BR',
    label: 'BR (+55)',
    prefix: '+55',
    digits: [8, 10, 11, 9]
  },
  {
    value: 'BS',
    label: 'BS (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'BT',
    label: 'BT (+975)',
    prefix: '+975',
    digits: [7, 8]
  },
  {
    value: 'BW',
    label: 'BW (+267)',
    prefix: '+267',
    digits: [7, 8, 10]
  },
  {
    value: 'BY',
    label: 'BY (+375)',
    prefix: '+375',
    digits: [6, 11, 9, 10]
  },
  {
    value: 'BZ',
    label: 'BZ (+501)',
    prefix: '+501',
    digits: [7, 11]
  },
  {
    value: 'CA',
    label: 'CA (+1)',
    prefix: '+1',
    digits: [10, 7]
  },
  {
    value: 'CC',
    label: 'CC (+61)',
    prefix: '+61',
    digits: [9, 7, 10, 6, 8, 12]
  },
  {
    value: 'CD',
    label: 'CD (+243)',
    prefix: '+243',
    digits: [7, 10, 9]
  },
  {
    value: 'CF',
    label: 'CF (+236)',
    prefix: '+236',
    digits: [8]
  },
  {
    value: 'CG',
    label: 'CG (+242)',
    prefix: '+242',
    digits: [9]
  },
  {
    value: 'CH',
    label: 'CH (+41)',
    prefix: '+41',
    digits: [9, 12]
  },
  {
    value: 'CI',
    label: 'CI (+225)',
    prefix: '+225',
    digits: [10]
  },
  {
    value: 'CK',
    label: 'CK (+682)',
    prefix: '+682',
    digits: [5]
  },
  {
    value: 'CL',
    label: 'CL (+56)',
    prefix: '+56',
    digits: [10, 11, 9]
  },
  {
    value: 'CM',
    label: 'CM (+237)',
    prefix: '+237',
    digits: [9, 8]
  },
  {
    value: 'CN',
    label: 'CN (+86)',
    prefix: '+86',
    digits: [10, 12, 7, 11, 8]
  },
  {
    value: 'CO',
    label: 'CO (+57)',
    prefix: '+57',
    digits: [10, 11]
  },
  {
    value: 'CR',
    label: 'CR (+506)',
    prefix: '+506',
    digits: [8, 10]
  },
  {
    value: 'CU',
    label: 'CU (+53)',
    prefix: '+53',
    digits: [6, 8, 10]
  },
  {
    value: 'CV',
    label: 'CV (+238)',
    prefix: '+238',
    digits: [7]
  },
  {
    value: 'CW',
    label: 'CW (+599)',
    prefix: '+599',
    digits: [7, 8]
  },
  {
    value: 'CX',
    label: 'CX (+61)',
    prefix: '+61',
    digits: [9, 7, 10, 6, 8, 12]
  },
  {
    value: 'CY',
    label: 'CY (+357)',
    prefix: '+357',
    digits: [8]
  },
  {
    value: 'CZ',
    label: 'CZ (+420)',
    prefix: '+420',
    digits: [9, 12]
  },
  {
    value: 'DE',
    label: 'DE (+49)',
    prefix: '+49',
    digits: [5, 15, 10, 11, 4, 14, 7, 8, 12, 13]
  },
  {
    value: 'DJ',
    label: 'DJ (+253)',
    prefix: '+253',
    digits: [8]
  },
  {
    value: 'DK',
    label: 'DK (+45)',
    prefix: '+45',
    digits: [8]
  },
  {
    value: 'DM',
    label: 'DM (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'DO',
    label: 'DO (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'DZ',
    label: 'DZ (+213)',
    prefix: '+213',
    digits: [8, 9]
  },
  {
    value: 'EC',
    label: 'EC (+593)',
    prefix: '+593',
    digits: [8, 9, 10, 11]
  },
  {
    value: 'EE',
    label: 'EE (+372)',
    prefix: '+372',
    digits: [7, 8, 10]
  },
  {
    value: 'EG',
    label: 'EG (+20)',
    prefix: '+20',
    digits: [8, 9, 10]
  },
  {
    value: 'EH',
    label: 'EH (+212)',
    prefix: '+212',
    digits: [9]
  },
  {
    value: 'ER',
    label: 'ER (+291)',
    prefix: '+291',
    digits: [7]
  },
  {
    value: 'ES',
    label: 'ES (+34)',
    prefix: '+34',
    digits: [9]
  },
  {
    value: 'ET',
    label: 'ET (+251)',
    prefix: '+251',
    digits: [9]
  },
  {
    value: 'FI',
    label: 'FI (+358)',
    prefix: '+358',
    digits: [5, 12, 9, 6, 10, 7, 8]
  },
  {
    value: 'FJ',
    label: 'FJ (+679)',
    prefix: '+679',
    digits: [7, 11]
  },
  {
    value: 'FK',
    label: 'FK (+500)',
    prefix: '+500',
    digits: [5]
  },
  {
    value: 'FM',
    label: 'FM (+691)',
    prefix: '+691',
    digits: [7]
  },
  {
    value: 'FO',
    label: 'FO (+298)',
    prefix: '+298',
    digits: [6]
  },
  {
    value: 'FR',
    label: 'FR (+33)',
    prefix: '+33',
    digits: [9]
  },
  {
    value: 'GA',
    label: 'GA (+241)',
    prefix: '+241',
    digits: [8, 7]
  },
  {
    value: 'GB',
    label: 'GB (+44)',
    prefix: '+44',
    digits: [9, 10, 7]
  },
  {
    value: 'GD',
    label: 'GD (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'GE',
    label: 'GE (+995)',
    prefix: '+995',
    digits: [9]
  },
  {
    value: 'GF',
    label: 'GF (+594)',
    prefix: '+594',
    digits: [9]
  },
  {
    value: 'GG',
    label: 'GG (+44)',
    prefix: '+44',
    digits: [10, 7, 9]
  },
  {
    value: 'GH',
    label: 'GH (+233)',
    prefix: '+233',
    digits: [8, 9]
  },
  {
    value: 'GI',
    label: 'GI (+350)',
    prefix: '+350',
    digits: [8]
  },
  {
    value: 'GL',
    label: 'GL (+299)',
    prefix: '+299',
    digits: [6]
  },
  {
    value: 'GM',
    label: 'GM (+220)',
    prefix: '+220',
    digits: [7]
  },
  {
    value: 'GN',
    label: 'GN (+224)',
    prefix: '+224',
    digits: [8, 9]
  },
  {
    value: 'GP',
    label: 'GP (+590)',
    prefix: '+590',
    digits: [9]
  },
  {
    value: 'GQ',
    label: 'GQ (+240)',
    prefix: '+240',
    digits: [9]
  },
  {
    value: 'GR',
    label: 'GR (+30)',
    prefix: '+30',
    digits: [10, 12]
  },
  {
    value: 'GT',
    label: 'GT (+502)',
    prefix: '+502',
    digits: [8, 11]
  },
  {
    value: 'GU',
    label: 'GU (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'GW',
    label: 'GW (+245)',
    prefix: '+245',
    digits: [9, 7]
  },
  {
    value: 'GY',
    label: 'GY (+592)',
    prefix: '+592',
    digits: [7]
  },
  {
    value: 'HK',
    label: 'HK (+852)',
    prefix: '+852',
    digits: [8, 9, 5, 11]
  },
  {
    value: 'HN',
    label: 'HN (+504)',
    prefix: '+504',
    digits: [11, 8]
  },
  {
    value: 'HR',
    label: 'HR (+385)',
    prefix: '+385',
    digits: [8, 9, 7, 6]
  },
  {
    value: 'HT',
    label: 'HT (+509)',
    prefix: '+509',
    digits: [8]
  },
  {
    value: 'HU',
    label: 'HU (+36)',
    prefix: '+36',
    digits: [8, 9]
  },
  {
    value: 'ID',
    label: 'ID (+62)',
    prefix: '+62',
    digits: [10, 17, 7, 11, 9, 12, 8]
  },
  {
    value: 'IE',
    label: 'IE (+353)',
    prefix: '+353',
    digits: [10, 7, 9]
  },
  {
    value: 'IL',
    label: 'IL (+972)',
    prefix: '+972',
    digits: [10, 8, 11, 12, 9, 7]
  },
  {
    value: 'IM',
    label: 'IM (+44)',
    prefix: '+44',
    digits: [10]
  },
  {
    value: 'IN',
    label: 'IN (+91)',
    prefix: '+91',
    digits: [8, 13, 10, 11]
  },
  {
    value: 'IO',
    label: 'IO (+246)',
    prefix: '+246',
    digits: [7]
  },
  {
    value: 'IQ',
    label: 'IQ (+964)',
    prefix: '+964',
    digits: [8, 9, 10]
  },
  {
    value: 'IR',
    label: 'IR (+98)',
    prefix: '+98',
    digits: [4, 5, 10, 6, 7]
  },
  {
    value: 'IS',
    label: 'IS (+354)',
    prefix: '+354',
    digits: [7, 9]
  },
  {
    value: 'IT',
    label: 'IT (+39)',
    prefix: '+39',
    digits: [9, 6, 11, 10, 8, 12]
  },
  {
    value: 'JE',
    label: 'JE (+44)',
    prefix: '+44',
    digits: [10]
  },
  {
    value: 'JM',
    label: 'JM (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'JO',
    label: 'JO (+962)',
    prefix: '+962',
    digits: [8, 9]
  },
  {
    value: 'JP',
    label: 'JP (+81)',
    prefix: '+81',
    digits: [8, 17, 9, 10]
  },
  {
    value: 'KE',
    label: 'KE (+254)',
    prefix: '+254',
    digits: [7, 9, 10]
  },
  {
    value: 'KG',
    label: 'KG (+996)',
    prefix: '+996',
    digits: [9, 10]
  },
  {
    value: 'KH',
    label: 'KH (+855)',
    prefix: '+855',
    digits: [8, 9, 10]
  },
  {
    value: 'KI',
    label: 'KI (+686)',
    prefix: '+686',
    digits: [5, 8]
  },
  {
    value: 'KM',
    label: 'KM (+269)',
    prefix: '+269',
    digits: [7]
  },
  {
    value: 'KN',
    label: 'KN (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'KP',
    label: 'KP (+850)',
    prefix: '+850',
    digits: [8, 10]
  },
  {
    value: 'KR',
    label: 'KR (+82)',
    prefix: '+82',
    digits: [11, 14, 5, 6, 8, 10, 9]
  },
  {
    value: 'KW',
    label: 'KW (+965)',
    prefix: '+965',
    digits: [8, 7]
  },
  {
    value: 'KY',
    label: 'KY (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'KZ',
    label: 'KZ (+7)',
    prefix: '+7',
    digits: [10, 14]
  },
  {
    value: 'LA',
    label: 'LA (+856)',
    prefix: '+856',
    digits: [8, 10, 9]
  },
  {
    value: 'LB',
    label: 'LB (+961)',
    prefix: '+961',
    digits: [7, 8]
  },
  {
    value: 'LC',
    label: 'LC (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'LI',
    label: 'LI (+423)',
    prefix: '+423',
    digits: [7, 9]
  },
  {
    value: 'LK',
    label: 'LK (+94)',
    prefix: '+94',
    digits: [9]
  },
  {
    value: 'LR',
    label: 'LR (+231)',
    prefix: '+231',
    digits: [8, 7, 9]
  },
  {
    value: 'LS',
    label: 'LS (+266)',
    prefix: '+266',
    digits: [8]
  },
  {
    value: 'LT',
    label: 'LT (+370)',
    prefix: '+370',
    digits: [8]
  },
  {
    value: 'LU',
    label: 'LU (+352)',
    prefix: '+352',
    digits: [4, 11, 9, 8, 10]
  },
  {
    value: 'LV',
    label: 'LV (+371)',
    prefix: '+371',
    digits: [8]
  },
  {
    value: 'LY',
    label: 'LY (+218)',
    prefix: '+218',
    digits: [9]
  },
  {
    value: 'MA',
    label: 'MA (+212)',
    prefix: '+212',
    digits: [9]
  },
  {
    value: 'MC',
    label: 'MC (+377)',
    prefix: '+377',
    digits: [8, 9]
  },
  {
    value: 'MD',
    label: 'MD (+373)',
    prefix: '+373',
    digits: [8]
  },
  {
    value: 'ME',
    label: 'ME (+382)',
    prefix: '+382',
    digits: [8, 9]
  },
  {
    value: 'MF',
    label: 'MF (+590)',
    prefix: '+590',
    digits: [9]
  },
  {
    value: 'MG',
    label: 'MG (+261)',
    prefix: '+261',
    digits: [9]
  },
  {
    value: 'MH',
    label: 'MH (+692)',
    prefix: '+692',
    digits: [7]
  },
  {
    value: 'MK',
    label: 'MK (+389)',
    prefix: '+389',
    digits: [8]
  },
  {
    value: 'ML',
    label: 'ML (+223)',
    prefix: '+223',
    digits: [8]
  },
  {
    value: 'MM',
    label: 'MM (+95)',
    prefix: '+95',
    digits: [6, 9, 7, 10, 8]
  },
  {
    value: 'MN',
    label: 'MN (+976)',
    prefix: '+976',
    digits: [8, 10]
  },
  {
    value: 'MO',
    label: 'MO (+853)',
    prefix: '+853',
    digits: [8, 7]
  },
  {
    value: 'MP',
    label: 'MP (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'MQ',
    label: 'MQ (+596)',
    prefix: '+596',
    digits: [9]
  },
  {
    value: 'MR',
    label: 'MR (+222)',
    prefix: '+222',
    digits: [8]
  },
  {
    value: 'MS',
    label: 'MS (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'MT',
    label: 'MT (+356)',
    prefix: '+356',
    digits: [8]
  },
  {
    value: 'MU',
    label: 'MU (+230)',
    prefix: '+230',
    digits: [7, 8, 10]
  },
  {
    value: 'MV',
    label: 'MV (+960)',
    prefix: '+960',
    digits: [7, 10]
  },
  {
    value: 'MW',
    label: 'MW (+265)',
    prefix: '+265',
    digits: [7, 9]
  },
  {
    value: 'MX',
    label: 'MX (+52)',
    prefix: '+52',
    digits: [10]
  },
  {
    value: 'MY',
    label: 'MY (+60)',
    prefix: '+60',
    digits: [8, 9, 10]
  },
  {
    value: 'MZ',
    label: 'MZ (+258)',
    prefix: '+258',
    digits: [8, 9]
  },
  {
    value: 'NA',
    label: 'NA (+264)',
    prefix: '+264',
    digits: [8, 9]
  },
  {
    value: 'NC',
    label: 'NC (+687)',
    prefix: '+687',
    digits: [6]
  },
  {
    value: 'NE',
    label: 'NE (+227)',
    prefix: '+227',
    digits: [8]
  },
  {
    value: 'NF',
    label: 'NF (+672)',
    prefix: '+672',
    digits: [6]
  },
  {
    value: 'NG',
    label: 'NG (+234)',
    prefix: '+234',
    digits: [8, 10, 14]
  },
  {
    value: 'NI',
    label: 'NI (+505)',
    prefix: '+505',
    digits: [8]
  },
  {
    value: 'NL',
    label: 'NL (+31)',
    prefix: '+31',
    digits: [5, 6, 9, 11, 7, 10]
  },
  {
    value: 'NO',
    label: 'NO (+47)',
    prefix: '+47',
    digits: [8, 5]
  },
  {
    value: 'NP',
    label: 'NP (+977)',
    prefix: '+977',
    digits: [8, 10, 11]
  },
  {
    value: 'NR',
    label: 'NR (+674)',
    prefix: '+674',
    digits: [7]
  },
  {
    value: 'NU',
    label: 'NU (+683)',
    prefix: '+683',
    digits: [4, 7]
  },
  {
    value: 'NZ',
    label: 'NZ (+64)',
    prefix: '+64',
    digits: [8, 10, 7, 9, 5]
  },
  {
    value: 'OM',
    label: 'OM (+968)',
    prefix: '+968',
    digits: [8, 7, 9]
  },
  {
    value: 'PA',
    label: 'PA (+507)',
    prefix: '+507',
    digits: [7, 8, 10, 11]
  },
  {
    value: 'PE',
    label: 'PE (+51)',
    prefix: '+51',
    digits: [8, 9]
  },
  {
    value: 'PF',
    label: 'PF (+689)',
    prefix: '+689',
    digits: [6, 8, 9]
  },
  {
    value: 'PG',
    label: 'PG (+675)',
    prefix: '+675',
    digits: [7, 8]
  },
  {
    value: 'PH',
    label: 'PH (+63)',
    prefix: '+63',
    digits: [6, 8, 10, 11, 13]
  },
  {
    value: 'PK',
    label: 'PK (+92)',
    prefix: '+92',
    digits: [9, 10, 8, 11, 12]
  },
  {
    value: 'PL',
    label: 'PL (+48)',
    prefix: '+48',
    digits: [7, 9, 6, 10]
  },
  {
    value: 'PM',
    label: 'PM (+508)',
    prefix: '+508',
    digits: [6, 9]
  },
  {
    value: 'PR',
    label: 'PR (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'PS',
    label: 'PS (+970)',
    prefix: '+970',
    digits: [8, 9, 10]
  },
  {
    value: 'PT',
    label: 'PT (+351)',
    prefix: '+351',
    digits: [9]
  },
  {
    value: 'PW',
    label: 'PW (+680)',
    prefix: '+680',
    digits: [7]
  },
  {
    value: 'PY',
    label: 'PY (+595)',
    prefix: '+595',
    digits: [7, 9, 11, 6]
  },
  {
    value: 'QA',
    label: 'QA (+974)',
    prefix: '+974',
    digits: [8, 7, 9, 11]
  },
  {
    value: 'RE',
    label: 'RE (+262)',
    prefix: '+262',
    digits: [9]
  },
  {
    value: 'RO',
    label: 'RO (+40)',
    prefix: '+40',
    digits: [6, 9]
  },
  {
    value: 'RS',
    label: 'RS (+381)',
    prefix: '+381',
    digits: [7, 12, 8, 10, 6]
  },
  {
    value: 'RU',
    label: 'RU (+7)',
    prefix: '+7',
    digits: [10, 14]
  },
  {
    value: 'RW',
    label: 'RW (+250)',
    prefix: '+250',
    digits: [8, 9]
  },
  {
    value: 'SA',
    label: 'SA (+966)',
    prefix: '+966',
    digits: [9, 10]
  },
  {
    value: 'SB',
    label: 'SB (+677)',
    prefix: '+677',
    digits: [5, 7]
  },
  {
    value: 'SC',
    label: 'SC (+248)',
    prefix: '+248',
    digits: [7]
  },
  {
    value: 'SD',
    label: 'SD (+249)',
    prefix: '+249',
    digits: [9]
  },
  {
    value: 'SE',
    label: 'SE (+46)',
    prefix: '+46',
    digits: [7, 9, 6, 10, 12]
  },
  {
    value: 'SG',
    label: 'SG (+65)',
    prefix: '+65',
    digits: [8, 10, 11]
  },
  {
    value: 'SH',
    label: 'SH (+290)',
    prefix: '+290',
    digits: [4, 5]
  },
  {
    value: 'SI',
    label: 'SI (+386)',
    prefix: '+386',
    digits: [8, 6, 5]
  },
  {
    value: 'SJ',
    label: 'SJ (+47)',
    prefix: '+47',
    digits: [8, 5]
  },
  {
    value: 'SK',
    label: 'SK (+421)',
    prefix: '+421',
    digits: [7, 9, 6]
  },
  {
    value: 'SL',
    label: 'SL (+232)',
    prefix: '+232',
    digits: [8]
  },
  {
    value: 'SM',
    label: 'SM (+378)',
    prefix: '+378',
    digits: [10, 8]
  },
  {
    value: 'SN',
    label: 'SN (+221)',
    prefix: '+221',
    digits: [9]
  },
  {
    value: 'SO',
    label: 'SO (+252)',
    prefix: '+252',
    digits: [6, 7, 9]
  },
  {
    value: 'SR',
    label: 'SR (+597)',
    prefix: '+597',
    digits: [6, 7]
  },
  {
    value: 'SS',
    label: 'SS (+211)',
    prefix: '+211',
    digits: [9]
  },
  {
    value: 'ST',
    label: 'ST (+239)',
    prefix: '+239',
    digits: [7]
  },
  {
    value: 'SV',
    label: 'SV (+503)',
    prefix: '+503',
    digits: [8, 7, 11]
  },
  {
    value: 'SX',
    label: 'SX (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'SY',
    label: 'SY (+963)',
    prefix: '+963',
    digits: [8, 9]
  },
  {
    value: 'SZ',
    label: 'SZ (+268)',
    prefix: '+268',
    digits: [8, 9]
  },
  {
    value: 'TA',
    label: 'TA (+290)',
    prefix: '+290',
    digits: [4]
  },
  {
    value: 'TC',
    label: 'TC (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'TD',
    label: 'TD (+235)',
    prefix: '+235',
    digits: [8]
  },
  {
    value: 'TG',
    label: 'TG (+228)',
    prefix: '+228',
    digits: [8]
  },
  {
    value: 'TH',
    label: 'TH (+66)',
    prefix: '+66',
    digits: [8, 9, 10, 13]
  },
  {
    value: 'TJ',
    label: 'TJ (+992)',
    prefix: '+992',
    digits: [9]
  },
  {
    value: 'TK',
    label: 'TK (+690)',
    prefix: '+690',
    digits: [4, 7]
  },
  {
    value: 'TL',
    label: 'TL (+670)',
    prefix: '+670',
    digits: [7, 8]
  },
  {
    value: 'TM',
    label: 'TM (+993)',
    prefix: '+993',
    digits: [8]
  },
  {
    value: 'TN',
    label: 'TN (+216)',
    prefix: '+216',
    digits: [8]
  },
  {
    value: 'TO',
    label: 'TO (+676)',
    prefix: '+676',
    digits: [5, 7]
  },
  {
    value: 'TR',
    label: 'TR (+90)',
    prefix: '+90',
    digits: [7, 10, 12, 13]
  },
  {
    value: 'TT',
    label: 'TT (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'TV',
    label: 'TV (+688)',
    prefix: '+688',
    digits: [5, 6, 7]
  },
  {
    value: 'TW',
    label: 'TW (+886)',
    prefix: '+886',
    digits: [8, 9, 7, 10, 11]
  },
  {
    value: 'TZ',
    label: 'TZ (+255)',
    prefix: '+255',
    digits: [9]
  },
  {
    value: 'UA',
    label: 'UA (+380)',
    prefix: '+380',
    digits: [9, 10]
  },
  {
    value: 'UG',
    label: 'UG (+256)',
    prefix: '+256',
    digits: [9]
  },
  {
    value: 'US',
    label: 'US (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'UY',
    label: 'UY (+598)',
    prefix: '+598',
    digits: [8, 6, 13, 7]
  },
  {
    value: 'UZ',
    label: 'UZ (+998)',
    prefix: '+998',
    digits: [9]
  },
  {
    value: 'VA',
    label: 'VA (+39)',
    prefix: '+39',
    digits: [6, 11, 9, 10, 8, 12]
  },
  {
    value: 'VC',
    label: 'VC (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'VE',
    label: 'VE (+58)',
    prefix: '+58',
    digits: [10]
  },
  {
    value: 'VG',
    label: 'VG (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'VI',
    label: 'VI (+1)',
    prefix: '+1',
    digits: [10]
  },
  {
    value: 'VN',
    label: 'VN (+84)',
    prefix: '+84',
    digits: [7, 8, 10, 9]
  },
  {
    value: 'VU',
    label: 'VU (+678)',
    prefix: '+678',
    digits: [5, 7]
  },
  {
    value: 'WF',
    label: 'WF (+681)',
    prefix: '+681',
    digits: [6, 9]
  },
  {
    value: 'WS',
    label: 'WS (+685)',
    prefix: '+685',
    digits: [5, 6, 7, 10]
  },
  {
    value: 'XK',
    label: 'XK (+383)',
    prefix: '+383',
    digits: [8, 12]
  },
  {
    value: 'YE',
    label: 'YE (+967)',
    prefix: '+967',
    digits: [7, 8, 9]
  },
  {
    value: 'YT',
    label: 'YT (+262)',
    prefix: '+262',
    digits: [9]
  },
  {
    value: 'ZA',
    label: 'ZA (+27)',
    prefix: '+27',
    digits: [9, 5, 10]
  },
  {
    value: 'ZM',
    label: 'ZM (+260)',
    prefix: '+260',
    digits: [9]
  },
  {
    value: 'ZW',
    label: 'ZW (+263)',
    prefix: '+263',
    digits: [5, 10, 9, 7]
  },
  {
    value: '001',
    label: '001 (+979)',
    prefix: '+979',
    digits: [9]
  }
]